import MaskInput from './MaskInput';

export default MaskInput;